import React, { Component } from 'react';




class PageContato extends Component {
  render() {
    return(    
        <div id="body">
          <h1 id="body-h1">Contato</h1>
          <p>
                Entre em contato conosco para mais informações sobre nossa empresa, nossos produtos e como podemos atender a suas necessidades.<br/><br/>
                Horário de Antendimento: De segunda a sexta-feira das 08h00 as 12h00 e das 13h00 as 17h45.<br/>
                Telefone: +55 (18) 4101-2869<br/>
                E-mail: dayka@dayka.com.br
          </p>
        </div>
    );
  }
}

export default PageContato;



// WEBPACK FOOTER //
// ./src/Pages/PageContato.js